import { useTopOfPageContent } from "@faire/retailer-visitor-shared/stores/ui/useTopOfPageContent";
import { debounceIfPossible } from "@faire/web--source/common/globals/debounceIfPossible";
import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { useEffect, useMemo, useRef } from "react";
export var useFilterablePaginatedScroll = function() {
    var scrollRef = useRef(null);
    // sticky header height will be set to 0 when user scroll down, since it will be hidden
    // when we call scrollToTop, the offsetTop is calculated based on the sticky header height 0
    // this will result in the page not scrolling to the correct position
    // topOfPageContentHeightRef is to keep track of the actual header height
    var topOfPageContentHeightRef = useRef(0);
    var headerPlusPromoBannerHeight = useTopOfPageContent().headerPlusPromoBannerHeight;
    useEffect(function() {
        if (headerPlusPromoBannerHeight) {
            topOfPageContentHeightRef.current = headerPlusPromoBannerHeight;
        }
    }, [
        headerPlusPromoBannerHeight
    ]);
    var scrollToTop = useMemo(function() {
        return debounceIfPossible(function(params) {
            var _scrollRef_current, _getWindowOrThrow_scrollTo, _getWindowOrThrow;
            var offsetTop = 0;
            if (params.toTop) {
                offsetTop = 0;
            } else if ((_scrollRef_current = scrollRef.current) === null || _scrollRef_current === void 0 ? void 0 : _scrollRef_current.offsetTop) {
                offsetTop = scrollRef.current.offsetTop - topOfPageContentHeightRef.current;
            }
            (_getWindowOrThrow_scrollTo = (_getWindowOrThrow = getWindowOrThrow()).scrollTo) === null || _getWindowOrThrow_scrollTo === void 0 ? void 0 : _getWindowOrThrow_scrollTo.call(_getWindowOrThrow, {
                top: offsetTop,
                left: 0,
                behavior: "smooth"
            });
        }, 100);
    }, []);
    return {
        scrollRef: scrollRef,
        scrollToTop: scrollToTop
    };
};
